module.exports = __webpack_public_path__ + "media/file_icons/default-9fc3fee0.png";